module.exports = __webpack_public_path__ + "static/media/Aaesha Shehhi.4afccdbc.png";